//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Calvert',
  data() {
    return {
      defaultJson:{
        "Target AUC": "目标 AUC",
        "Dose": "剂量",
        "Creat. Clearance": "肌酐清除率"
      },
      form:{
        gfr:'',
        auc:'',

      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'男'},
        {value:"5",name:'女'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {  
        // gender.isFemale ?		(1.04 * auc * (140 - gfr) / creat) :		(1.23 * auc * (140 - gfr) / creat)
        let result = form.auc * (form.gfr + 25)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Diab/Calvert.vue